export const ISPM_MFE_CONFIG = {
  packageName: '@saviynt/ispm-ui',
  routePrefix: '/ECMv6/intelligence/ispm',
  containerId: 'ispm-mfe-content',
  errorContainerId: 'ispm-mfe-error',
};

export const ISPM_INTEGRATIONS_MFE_CONFIG = {
  packageName: '@saviynt/integrations',
  routePrefix: '/ECMv6/intelligence/integrations',
  containerId: 'integrations-mfe-content',
  errorContainerId: 'integrations-mfe-error',
};